import { useContext } from 'react';
import { CalculatorCurrencyContext } from '../contexts/CalculatorContext';
import { calculatorCurrencyValues, CalculatorCurrencyValuesType } from '../constants/calculator_currency.constant';

export function CalculatorCurrency(): JSX.Element {
    const [calculatorCurrency, setCalculatorCurrency] = useContext(CalculatorCurrencyContext)!;

    return (
        <div className="selectCurrency">

            <label htmlFor="currency">Country / Currency</label>
            <select name="currency" className="purple"
                    onChange={event => setCalculatorCurrency(event.target.value as CalculatorCurrencyValuesType)}
                    value={calculatorCurrency || ''}>
                {
                    calculatorCurrencyValues?.map((e, i) => {
                        return (
                            <option key={i}
                                    value={e}>
                                {e}
                            </option>
                        );
                    }) || ''
                }
            </select>
        </div>
    );
}
